import { Component } from '@angular/core';
import { ImmediateTopUpLoadFormComponent } from '../immediate-top-up-load-form/immediate-top-up-load-form.component';
import { Method } from '@bo/ng-api';
import { CurrencyPipe, NgClass } from '@angular/common';
import { FieldComponent } from '../../../../../../shared/components/forms/form-field/form-field.component';
import { FieldPathDirective, FormNonFieldErrorsComponent, FormOptionsDirective } from '@bo/ng-forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SubmitComponent } from '../../../../../../shared/components/forms/submit/submit.component';
import { LoaderComponent } from '../../../../../../shared/components/loader/loader.component';
import { CardFundsRequest } from '../../../../../../_interfaces/cards.interface';
import { Observable } from 'rxjs';
import { EmptyIndicatorPipe } from '../../../../../../shared/pipes/empty-indicator.pipe';

@Component({
  selector: 'app-immediate-top-up-deduct-form',
  imports: [
    CurrencyPipe,
    FieldComponent,
    FieldPathDirective,
    FormNonFieldErrorsComponent,
    ReactiveFormsModule,
    SubmitComponent,
    FormOptionsDirective,
    NgClass,
    LoaderComponent,
    EmptyIndicatorPipe,
  ],
  templateUrl: '../immediate-top-up-load-form/immediate-top-up-load-form.component.html',
})
export class ImmediateTopUpDeductFormComponent extends ImmediateTopUpLoadFormComponent {
  override createForm(): void {
    const options$ = this.cardsApiService.getOptions(this.cardsApiService.URL_CARD_FUNDS_DEDUCT + '/', Method.POST);
    this.subscriptions.add(
      this.buildFromOptions(options$).subscribe({
        next: () => {
          if (this.cardBalanceError()) {
            this.form.get('amount')?.disable();
          } else {
            this.handleTopUpAmountChanges();
            this.setLimitError();
          }
        },
      }),
    );
  }

  override submitData(formData: CardFundsRequest): Observable<CardFundsRequest> {
    if (this.selectedCardId()) formData.card = this.selectedCardId();
    return this.cardsApiService.deductCardFunds(formData);
  }
}
